// React
import React from 'react';
// External
import { Col, Form } from 'react-bootstrap';
import SelectSearch from 'react-select-search';
import { BsChevronDown } from 'react-icons/bs';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import NavbarSecondary from 'components/shared/organisms/NavbarSecondary/NavbarSecondary';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import FooterBtnActions from 'components/shared/molecules/FooterBtnActions/FooterBtnActions';
import getFormFieldVal from 'utils/getFormFieldVal';
import validateForm from 'utils/validateForm';
import { getMember, updateMember } from 'services/managePractice';
import newMember from 'models/Member';
import MEMBER_STATUS_LIST from 'constants/memberStatusList';
import ACCESS_LEVEL_LIST from 'constants/accessLevelList';
// Styles
import './styles.scss';
import AlertDismissible from 'components/shared/atoms/AlertDismissible/AlertDismissible';

class ViewMember extends React.Component {
    constructor(props) {
        super(props);
        // If member ID is pass through props (profile page)
        let memberId;
        let isManager = false;
        if (props.memberId) {
            ({ memberId } = props);
        } else if (props.match && Object.hasOwnProperty.call(props.match.params, 'id')) {
            // If member ID is in the url
            memberId = props.match.params.id;
            isManager = true;
        }
        this.state = {
            member: newMember(),
            memberId,
            errors: [],
            isManager,
            showAlertSuccess: false
        };
        this.getMemberDetails();

        this.selectSearchRefs =  {
            access_level: React.createRef(),
            member_status: React.createRef(),
        };
        this.bOpenOptions = false;
        this.bEnterPressed = false;
    }

    handleInputChange(event) {
        const fieldObj = getFormFieldVal(event);
        event.target.classList.remove('is-invalid');
        // Updates the state
        this.setState((prevState) => {
            const member = { ...prevState.member, ...fieldObj };
            return { member };
        });
    }

    handleInputSelectChange(field, value) {
        const obj = {};
        obj[field] = value;
        // Updates the state
        this.setState((prevState) => {
            const member = { ...prevState.member, ...obj };
            return { member };
        });
    }

    /**
     * Function call from the parent component
     */
    async onClickSubmit() {
        let errors = [];
        await this.setState((prevState) => {
            errors = validateForm(prevState.member);
            return { errors };
        });
        // Exists before sending the request
        if (errors.length > 0) {
            return;
        }
        // If form has no errors then updates the member data
        updateMember(this.state.memberId, this.state.member.getSugarAPIFormat())
            .then(() => {
                if (this.state.isManager) {
                    this.props.history.push('/manage-practice');
                } else {
                    this.props.history.push('/dashboard');
                }
            }).catch(() => {
                /**
                 * @todo Display an error message
                 */
            });
    }

    getMemberDetails() {
        getMember(this.state.memberId)
            .then((response) => {
                this.setState({ member: newMember(response.data) });
            }).catch((err) => {
                console.error(err);
            });
    }

    hasError(fieldError) {
        return this.state.errors.find((error) => error === fieldError);
    }

    render() {
        return (
            <div className="main-container">
                <NavbarSecondary />
                <NavbarPrimary />
                <div className="body-content">
                    <PageTitle title="View member" />
                    <ContentCard
                        className="mt-62"
                        headerTitle={`${this.state.member.firstName} ${this.state.member.lastName}`}
                    >
                        <Form className="custom-inline-form">
                            <Form.Row>
                                <Form.Group as={Col} controlId="firstName" className="control-group">
                                    <Form.Label>FIRST NAME</Form.Label>
                                    <Form.Control
                                        className={
                                            this.hasError('firstName')
                                                ? 'is-invalid'
                                                : ''
                                        }
                                        name="firstName"
                                        onChange={(event) => this.handleInputChange(event)}
                                        type="text"
                                        placeholder="Given name"
                                        value={this.state.member.firstName}
                                        disabled
                                    />
                                </Form.Group>
                                <Form.Group as={Col} controlId="lastName" className="control-group">
                                    <Form.Label>LAST NAME</Form.Label>
                                    <Form.Control
                                        className={
                                            this.hasError('lastName')
                                                ? 'is-invalid'
                                                : ''
                                        }
                                        name="lastName"
                                        onChange={(event) => this.handleInputChange(event)}
                                        type="text"
                                        placeholder="Last name"
                                        value={this.state.member.lastName}
                                        disabled
                                    />
                                </Form.Group>
                            </Form.Row>
                            <Form.Row>
                                <Form.Group as={Col} controlId="email" className="control-group">
                                    <Form.Label>EMAIL</Form.Label>
                                    <Form.Control
                                        className={
                                            this.hasError('email')
                                                ? 'is-invalid'
                                                : ''
                                        }
                                        name="email"
                                        onChange={(event) => this.handleInputChange(event)}
                                        type="text"
                                        placeholder="Email"
                                        value={this.state.member.email}
                                        disabled
                                    />
                                </Form.Group>
                                {
                                    this.state.isManager
                                        ? (
                                            <Form.Group as={Col} controlId="accessLevel" className="control-group">
                                                <Form.Label>ACCESS LEVEL</Form.Label>
                                                <div className="selector">
                                                    <SelectSearch
                                                        ref={this.selectSearchRefs.access_level}
                                                        options={ACCESS_LEVEL_LIST}
                                                        onChange={(value) => {
                                                            this.handleInputSelectChange('accessLevel', value);

                                                            // If the enter key is pressed, set it back to false and then focus back to the dropdown
                                                            if (this.bEnterPressed) {
                                                                this.bEnterPressed = false;
                                                                setTimeout(() => this.selectSearchRefs.access_level.current.querySelector('input').focus(), 50);
                                                            }
                                                        }}
                                                        renderValue={(valueProps) => (
                                                            <Form.Control
                                                                {...valueProps}
                                                                className={
                                                                    this.hasError('accessLevel')
                                                                        ? 'is-invalid'
                                                                        : ''
                                                                }
                                                                name="accessLevel"
                                                                type="text"
                                                                placeholder="Access level"
                                                                value={this.state.member.getAccessLevelLabel()}
                                                                onMouseDownCapture={objEvent => {
                                                                    this.bOpenOptions = true;
                                                                }}
                                                                onFocusCapture={objEvent => {
                                                                    if (!this.bOpenOptions) {
                                                                        objEvent.stopPropagation();
                                                                    } else {
                                                                        this.bOpenOptions = false;
                                                                    }
                                                                }}
                                                                onKeyDownCapture={objEvent => {
                                                                    if (objEvent.key === 'Tab') {
                                                                        try {
                                                                            // Get the currently highlighted option and use it as the selected value
                                                                            const value = objEvent.target.parentElement.parentElement.querySelector('.is-highlighted').value;
                                                                            
                                                                            this.handleInputSelectChange('accessLevel', value)
                                                                        } catch(objError) {
                                                                            console.log('Error in selecting access level options: ', objError);
                                                                        }
                                                                    }

                                                                    // If the enter key is pressed, set the flag to true and then set the open options flag to false
                                                                    if (objEvent.key === 'Enter') {
                                                                        this.bOpenOptions = false;
                                                                        this.bEnterPressed = true;
                                                                    }

                                                                    // If the arrow up or down is pressed, open the options
                                                                    if (objEvent.key === 'ArrowUp' || objEvent.key === 'ArrowDown') {
                                                                        this.selectSearchRefs.access_level.current.querySelector('input').blur();

                                                                        this.bOpenOptions = true;            

                                                                        this.selectSearchRefs.access_level.current.querySelector('input').focus();
                                                                    }
                                                                }}
                                                            />
                                                        )}
                                                    />
                                                    <BsChevronDown />
                                                </div>
                                            </Form.Group>
                                        ) : <Form.Group as={Col} className="control-group" />
                                }
                            </Form.Row>
                            {
                                this.state.isManager
                                    ? (
                                        <Form.Row>
                                            <Form.Group as={Col} controlId="memberStatus" className="control-group">
                                                <Form.Label>MEMBER STATUS</Form.Label>
                                                <SelectSearch
                                                    ref={this.selectSearchRefs.member_status}
                                                    options={MEMBER_STATUS_LIST}
                                                    onChange={(value) => {
                                                        this.handleInputSelectChange('memberStatus', value);

                                                        // If the enter key is pressed, set it back to false and then focus back to the dropdown
                                                        if (this.bEnterPressed) {
                                                            this.bEnterPressed = false;
                                                            setTimeout(() => this.selectSearchRefs.member_status.current.querySelector('input').focus(), 50);
                                                        }
                                                    }}
                                                    renderValue={(valueProps) => (
                                                        <div className="selector">
                                                            <Form.Control
                                                                {...valueProps}
                                                                className={
                                                                    this.hasError('memberStatus')
                                                                        ? 'is-invalid'
                                                                        : ''
                                                                }
                                                                name="memberStatus"
                                                                onChange={(event) => this.handleInputChange(event)}
                                                                type="text"
                                                                placeholder="Member status"
                                                                value={this.state.member.getMemberStatusLabel()}
                                                                onMouseDownCapture={objEvent => {
                                                                    this.bOpenOptions = true;
                                                                }}
                                                                onFocusCapture={objEvent => {
                                                                    if (!this.bOpenOptions) {
                                                                        objEvent.stopPropagation();
                                                                    } else {
                                                                        this.bOpenOptions = false;
                                                                    }
                                                                }}
                                                                onKeyDownCapture={objEvent => {
                                                                    if (objEvent.key === 'Tab') {
                                                                        try {
                                                                            // Get the currently highlighted option and use it as the selected value
                                                                            const value = objEvent.target.parentElement.parentElement.parentElement.querySelector('.is-highlighted').value;
                                                                            
                                                                            this.handleInputSelectChange('memberStatus', parseInt(value));
                                                                        } catch(objError) {
                                                                            console.log('Error in selecting member status options: ', objError);
                                                                        }
                                                                    }

                                                                    // If the enter key is pressed, set the flag to true and then set the open options flag to false
                                                                    if (objEvent.key === 'Enter') {
                                                                        this.bOpenOptions = false;
                                                                        this.bEnterPressed = true;
                                                                    }

                                                                    // If the arrow up or down is pressed, open the options
                                                                    if (objEvent.key === 'ArrowUp' || objEvent.key === 'ArrowDown') {
                                                                        this.selectSearchRefs.member_status.current.querySelector('input').blur();

                                                                        this.bOpenOptions = true;            

                                                                        this.selectSearchRefs.member_status.current.querySelector('input').focus();
                                                                    }
                                                                }}
                                                            />
                                                            <BsChevronDown />
                                                        </div>
                                                    )}
                                                />
                                            </Form.Group>
                                            <Form.Group as={Col} className="control-group" />
                                        </Form.Row>
                                    ) : null
                            }
                        </Form>
                    </ContentCard>
                </div>
                <FooterBtnActions
                    nextBtnText="Update profile"
                    nextBtnIconActive="false"
                    nextBtnOnCLick={() => this.onClickSubmit()}
                />
                <AlertDismissible
                    show={this.state.showAlertSuccess}
                    text="Information updated successfully."
                    type="success"
                    onClose={(val) => { this.setState({ showAlertSuccess: val }); }}
                />
            </div>
        );
    }
}

export default ViewMember;
